import React, { useRef, useMemo, useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import JoditEditor from 'jodit-react';
import { Box } from '@mui/material';

interface EditorInputProps {
  name: string; // The name prop for React Hook Form
  placeholder?: string; // Optional placeholder text
  sx?: React.CSSProperties; // Optional styling prop
  onReady?: (editor: any) => void; // Callback when the editor is ready
}

const CkEditorInput = ({ name, placeholder, sx = {}, onReady }: EditorInputProps) => {
  const { control } = useFormContext();
  const editor = useRef<any>(null); // Use `any` for the editor instance

  const config = useMemo(
    () => ({
      readonly: false, // Set to true for read-only mode
      placeholder: placeholder || 'Start typing...',
      buttons: [
        'bold',
        'underline',
        'italic',
        '|',
        'ul',
        'ol',
        '|',
        'fontsize',
        'paragraph',
        '|',
        'table',
        'align',
        'undo',
        'redo',
        '|',
        'hr',
        'fullsize',
        'print',
        'about',
      ],
    }),
    [placeholder]
  );

  // Call the `onReady` function when the editor is initialized
  useEffect(() => {
    if (onReady && editor.current) {
      onReady(editor.current); // Pass the editor instance to the `onReady` callback
    }
  }, [onReady]);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Box sx={{ ...sx, direction: 'rtl' }}>
          <JoditEditor
            ref={editor}
            value={field.value || ''}
            config={config}
            onBlur={(newContent) => field.onChange(newContent)} // Update content on blur
            onChange={(newContent) => {}} // Optional: handle onChange if needed
          />
        </Box>
      )}
    />
  );
};

export default CkEditorInput;
